const SESSION_TOKEN = 'SESSION_TOKEN';
const GOOGLE_ACCOUNT_DONT_REMIND_ME = 'GOOGLE_ACCOUNT_DONT_REMIND_ME';
const DISPLAY_MODE = 'DISPLAY_MODE';
const ISAT_WARNING_ACKNOWLEDGED = 'ISAT_WARNING_ACKNOWLEDGED';
const NAV_VISITED = 'NAV_VISITED';
const TUTORIAL_VIEWED = 'TUTORIAL_VIEWED';
const IS_IRAPO = 'IS_IRAPO'; // if IRAPO staff or not, to keep track to not send analytics
const REPORT_RATING = 'REPORT_RATING'; // a JSON string of an object with report id as the key and true if up, false if down
const FEEDBACK_ANNOUNCEMENT = 'FEEDBACK_ANNOUNCEMENT';
const WAT_CHART_DEFINITIONS_OPEN = 'WAT_CHART_DEFINITIONS_OPEN';

/* Wrap localStorage just in case it's unavailable */
function isLocalStorageAvailable() {
  const val = 'ls_test';
  try {
    localStorage.setItem(val, val);
    localStorage.removeItem(val);
    return true;
  }
  catch (error) {
    return false;
  }
}

/**
 * Gets an item stored in local storage with the given key.
 */
function getItem(key) {
  if (isLocalStorageAvailable()) {
    return localStorage.getItem(key) || '';
  }
  return null;
}

/* Define storage keys in one place to prevent unintentional collisions */
export default {
  DISPLAY_MODE,
  GOOGLE_ACCOUNT_DONT_REMIND_ME,
  ISAT_WARNING_ACKNOWLEDGED,
  IS_IRAPO,
  SESSION_TOKEN,
  NAV_VISITED,
  TUTORIAL_VIEWED,
  REPORT_RATING,
  FEEDBACK_ANNOUNCEMENT,
  WAT_CHART_DEFINITIONS_OPEN,
  getItem,
  getBoolean(key) {
    return (getItem(key) || 'false') === 'true';
  },
  removeItem(key) {
    if (isLocalStorageAvailable()) {
      localStorage.removeItem(key);
    }
  },
  setItem(key, value) {
    if (isLocalStorageAvailable()) {
      localStorage.setItem(key, value);
    }
  }
};